import callApi from "@repo/next-shared/utils/api";
import { useQuery } from "@tanstack/react-query";
import { SearchProductsResponse } from "@/types/product-search";

// export async function getCategoryMostViewed(id: string) {
//   return await cacheApiData<any, CatalogProductViewResponse>(redisKeys.CATEGORY_MOSTVIEWED(id), {
//     path: `/catalog/category/${id}/most-viewed-products?limit=7`,
//     method: "GET",
//   })
// }

export async function getCategoryMostViewed(id: string) {
  return await callApi<any[]>({
    path: `/catalog/category/${id}/most-viewed-products?limit=7`,
    method: "GET",
  });
}

export function useCategoryMostViewedBase(id: string, select: any): any {
  return useQuery({
    queryKey: ["mostviewed", id],
    queryFn: () => getCategoryMostViewed(id),
    select,
  });
}

export function useCategoryMostViewed(id: string) {
  return useCategoryMostViewedBase(
    id,
    (data: SearchProductsResponse) => data.list,
  );
}
